<template>
  <div class="text-center">
    <h3 class="text-lg leading-6 font-medium text-gray-800">
      {{ confirm.header }}
    </h3>
    <div class="mt-2">
      <p 
        v-if="confirm.text && confirm.text != ''"
        class="text-sm text-gray-500"
      >
        {{ confirm.text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    confirm: {
      type: Object,
      default: null
    }
  },
}
</script>

<style scoped>
</style>
